module.exports = __webpack_public_path__ + "static/img/3_6_1.827b090d.jpg";